import { ListItem, SxProps, Box, Stack } from '@mui/material';
import { colors } from '@sweep-io/sweep-design';
import { TruncatedTextTooltip } from './TruncatedTextTooltip';

interface StyledListItemProps {
  id?: string;
  isActive?: boolean;
  onClick?: (event: any) => void;
  title: React.ReactNode;
  sx?: SxProps;
  ListItemTag?: React.ReactNode;
  StartIcon?: React.ReactNode;
  EndAdornment?: React.ReactNode;
  children?: React.ReactNode;
  subtitle?: string;
}

export const StyledListItem = ({
  id,
  isActive,
  title,
  onClick,
  sx,
  ListItemTag,
  StartIcon,
  EndAdornment,
  children,
  subtitle,
}: StyledListItemProps) => {
  return (
    <ListItem
      id={id}
      key={id}
      onClick={(event) => onClick && onClick(event)}
      sx={{
        cursor: isActive || !onClick ? 'default' : 'pointer',
        fontWeight: isActive ? 800 : '',
        backgroundColor: isActive ? colors.grey[100] : 'transparent',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        gap: 1,
        '&:hover': {
          backgroundColor: colors.grey[100],
        },
        '& svg path': {
          stroke: isActive && !ListItemTag ? colors.blue[500] : colors.grey[700],
        },
        padding: '10px',
        maxHeight: '40px',
        ...sx,
      }}
    >
      <Stack justifyContent="space-between" minWidth={0}>
        <Box
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 1.5,
            width: '100%',
            minWidth: 0,
          }}
        >
          {children}
          {StartIcon && StartIcon}
          <Stack minWidth={0}>
            <TruncatedTextTooltip
              variant={isActive ? 'body-bold' : 'body'}
              color={isActive ? colors.blue[500] : 'inherit'}
            >
              {title}
            </TruncatedTextTooltip>

            {subtitle && (
              <TruncatedTextTooltip variant="caption" color={colors.grey[700]}>
                {subtitle}
              </TruncatedTextTooltip>
            )}
          </Stack>
          {ListItemTag}
        </Box>
      </Stack>
      {EndAdornment}
    </ListItem>
  );
};
